//React
import { FunctionComponent, ReactNode } from "react"

interface Props {
    isLink: boolean
    hasBeenClicked: boolean
    data: ReactNode
    title?: string
    onClick: () => void
}

const VehicleIncidentsTableBodyTDCellText: FunctionComponent<Props> = ({
    isLink,
    hasBeenClicked,
    data,
    title,
    onClick,
}) => (
    <div
        className={`VehicleIncidentsTableBodyTDText ${isLink ? "VehicleIncidentsTableBodyTDTextIsLink" : ""
            }`}
    >
        {isLink ? (
            <div
                className={`VehicleIncidentsTableBodyTDTextVideo ${hasBeenClicked
                        ? "VehicleIncidentsTableBodyTDTextVideoClicked"
                        : ""
                    }`}
            >
                {data && (
                    <span
                        className={
                            hasBeenClicked ? "material-icons" : "material-icons-outlined"
                        }
                        onClick={onClick}
                    >
                        play_circle
                    </span>
                )}
            </div>
        ) : (
            // Clamped to one line so no value can push the row past its fixed height.
            // The title carries the full value for anything that gets cut off.
            <span className="VehicleIncidentsTableBodyTDTextValue" title={title}>
                {data}
            </span>
        )}
    </div>
)

export default VehicleIncidentsTableBodyTDCellText
